var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11208_374862)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94 14L19.8066 11.14C19.9322 11.0145 20.0027 10.8442 20.0027 10.6667C20.0027 10.4891 19.9322 10.3189 19.8066 10.1933C19.6811 10.0678 19.5108 9.99728 19.3333 9.99728C19.1558 9.99728 18.9855 10.0678 18.86 10.1933L16 13.06L13.14 10.1933C13.0144 10.0678 12.8442 9.99728 12.6666 9.99728C12.4891 9.99728 12.3188 10.0678 12.1933 10.1933C12.0678 10.3189 11.9972 10.4891 11.9972 10.6667C11.9972 10.8442 12.0678 11.0145 12.1933 11.14L15.06 14L12.1933 16.86C12.1308 16.922 12.0812 16.9957 12.0474 17.077C12.0135 17.1582 11.9961 17.2453 11.9961 17.3333C11.9961 17.4214 12.0135 17.5085 12.0474 17.5897C12.0812 17.671 12.1308 17.7447 12.1933 17.8067C12.2553 17.8692 12.329 17.9188 12.4102 17.9526C12.4915 17.9865 12.5786 18.0039 12.6666 18.0039C12.7546 18.0039 12.8418 17.9865 12.923 17.9526C13.0042 17.9188 13.078 17.8692 13.14 17.8067L16 14.94L18.86 17.8067C18.9219 17.8692 18.9957 17.9188 19.0769 17.9526C19.1581 17.9865 19.2453 18.0039 19.3333 18.0039C19.4213 18.0039 19.5084 17.9865 19.5897 17.9526C19.6709 17.9188 19.7446 17.8692 19.8066 17.8067C19.8691 17.7447 19.9187 17.671 19.9526 17.5897C19.9864 17.5085 20.0038 17.4214 20.0038 17.3333C20.0038 17.2453 19.9864 17.1582 19.9526 17.077C19.9187 16.9957 19.8691 16.922 19.8066 16.86L16.94 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11208_374862",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11208_374862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11208_374862",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossError);
export default __webpack_public_path__ + "static/media/cross-error.9a8a47f3d16f63275a05541ee4064351.svg";
export { ForwardRef as ReactComponent };